import React from 'react';

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
  isActive?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm py-2">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className="text-gray-400">/</span>}
          {item.onClick && !item.isActive ? (
            <button
              onClick={item.onClick}
              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
            >
              {item.label}
            </button>
          ) : (
            <span className={item.isActive ? "text-gray-900 dark:text-white font-medium" : "text-gray-600 dark:text-gray-400"}>
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};